export default function hoursAndMinutes(value) {
  if (Number.isNaN(value)) {
    console.log('HourAndMinutesPipe received a value that is not a number: ', value);
    return '--';
  }

  const hours = Math.floor(value);
  const minutes = Math.floor((value - hours) * 60);

  if (!minutes) {
    return `${hours}hr`;
  }

  if (!hours) {
    return `${minutes}min`;
  }

  return `${hours}hr ${minutes}min`;
}
